<div class="harp-table-wrapper" role="table" attr.aria-label="{{ tableName }}">
  <!-- Table Headers -->
  <div role="rowgroup" class="d-none d-md-block">
    <div
      id="table-headers-{{ formName }}"
      class="harp-table-header harp-nowrap row fw-bold"
      role="row"
    >
      <!-- Checkbox Column -->
      <div
        *ngIf="hasCheckbox"
        class="col-1"
        role="columnheader"
        aria-label="Checkbox column"
      >
        <input
          type="checkbox"
          (change)="toggleCheckAll()"
          [checked]="allChecked"
          name="Select All"
        />
      </div>

      <div
        *ngFor="let column of columns"
        [ngClass]="column.class"
        [ngStyle]="column.style"
        role="columnheader"
        (click)="column.canSort && sortBy(column.key, !isAsc)"
      >
        <p [ngClass]="{ 'visually-hidden': !column.showHeader }">
          {{ column.header }}

          <!-- Header Tooltip-->
          <button
            *ngIf="column.headerTooltip"
            placement="top"
            [ngbTooltip]="column.headerTooltip?.getValue()"
            class="harp-tooltip"
          >
            <i aria-hidden="true" class="icon ion-md-information-circle"></i
            ><span class="visually-hidden">{{ column.header }}</span>
          </button>

          <!-- Column Sort Indicators -->
          <span *ngIf="column.canSort">
            <span *ngIf="this.sortColumnName === column.key && this.isAsc">
              <em class="icon ion-ios-arrow-up"></em>
            </span>
            <span *ngIf="this.sortColumnName === column.key && !this.isAsc">
              <em class="icon ion-ios-arrow-down"></em>
            </span>
          </span>
        </p>
      </div>
    </div>
  </div>

  <!-- Table Body -->
  <div
    id="table-body-{{ formName }}"
    class="harp-table"
    role="rowgroup"
    *ngIf="!usePagination"
  >
    <div
      class="row"
      *ngFor="
        let entry of sortedData
          | slice
            : (pageNumber - 1) * pageSize
            : (pageNumber - 1) * pageSize + pageSize;
        let i = index;
        let rowNum = index
      "
      role="row"
    >
      <!-- Checkbox Column -->
      <div *ngIf="hasCheckbox" class="col-1" role="cell">
        <input
          type="checkbox"
          [value]="entry"
          (change)="onCheckboxChange(entry)"
          [checked]="isChecked(entry)"
          name="{{ i }}"
        />
        <label for="{{ i }}" class="visually-hidden">
          {{ getCheckboxLabel(entry) || '' }}
        </label>
      </div>

      <div
        *ngFor="let column of columns"
        [ngClass]="column.class"
        [ngStyle]="column.style"
        style="word-wrap: break-word"
        class="d-md-block"
        role="cell"
        #colRef
      >
        <div>
          <p
            *ngIf="column.showHeader"
            class="fw-bold d-md-none"
            role="columnheader"
          >
            {{ column.header }}
          </p>

          <div
            *ngIf="!column.actions && !column.link && entry[column.key] !== ''"
            [id]="getContentId(column.key, entry.rowId)"
          >
            <!-- Expand Truncated Content Button -->
            <button
              *ngIf="
                column.truncate && shouldRenderTruncateButton(colRef, rowNum)
              "
              class="btn btn-link float-end"
              (click)="colRef.clicked = !colRef.clicked"
            >
              <em
                [ngClass]="{
                  'icon ion-md-add': !colRef.clicked,
                  'icon ion-md-remove': colRef.clicked
                }"
                class="add-remove-icon"
              ></em>
            </button>

            <!-- Non Truncated Content-->
            <span
              *ngIf="!column.truncate || colRef.clicked"
              [attr.data-matomo-mask]="maskData ? '' : null"
            >
              {{ format(entry[column.key], column.pipes) }}
            </span>

            <!-- Truncated Content -->
            <span
              *ngIf="column.truncate && !colRef.clicked"
              [attr.data-matomo-mask]="maskData ? '' : null"
              class="ellipsis"
              [ngStyle]="{
                '-webkit-line-clamp': maxHeight(colRef, column, rowNum)
              }"
            >
              {{ format(entry[column.key], column.pipes) }}
            </span>

            <!-- Tooltip -->
            <ng-template #tipContent>
              <div [innerHTML]="column?.tooltip?.getValue(entry)"></div>
            </ng-template>

            <button
              *ngIf="column.tooltip && column.tooltip.shouldShow(entry)"
              class="harp-comments"
              placement="top"
              [ngbTooltip]="tipContent"
              aria-label="Request Comments"
            >
              <em class="icon {{ getTooltipIcon(column) }}"></em>
            </button>
          </div>

          <!-- Link -->
          <ng-container *ngIf="!column.actions && column.link">
            <div style="display: flex; align-items: center">
              <span
                *ngIf="
                  column?.tooltip?.shouldShow(entry) &&
                  column?.tooltip?.cmsShield
                "
                placement="top"
                [ngbTooltip]="tipContent"
                tooltipClass="cms-shield-tooptip"
                style="margin-right: 5px"
              >
                <svg style="height: 16px; width: 16px">
                  <path
                    d="M15.8663 3.37257L15.8383 2.92788L15.3996 2.84944C12.3297 2.29864 11.0482 1.90044 8.1834 0.60647L7.94952 0.5L7.71564 0.60647C4.85088 1.90044 3.56933 2.29864 0.499438 2.84944L0.0607808 2.92788L0.0327436 3.37257C-0.103893 5.54137 0.18748 7.56217 0.899767 9.37891C1.48305 10.8608 2.34628 12.2165 3.44228 13.3719C5.33993 15.3853 7.35471 16.2597 7.73906 16.4145L7.952 16.5L8.16494 16.4145C8.5493 16.2597 10.5641 15.3853 12.4617 13.3719C13.556 12.2161 14.4175 10.8604 14.9993 9.37891C15.7116 7.56217 16.0029 5.54137 15.8663 3.37257ZM6.89049 11.0384L4.30717 8.50586L5.10215 7.69455L6.82235 9.37998L10.7309 4.86564L11.5897 5.6088L6.89049 11.0384Z"
                    fill="#046B99"
                  />
                </svg>
              </span>
              <a
                *ngIf="!column.actions && column.link"
                [attr.data-matomo-mask]="maskData ? '' : null"
                [routerLink]=""
                (click)="column.link(entry)"
                [id]="getContentId(column.key, entry.rowId)"
              >
                {{ format(entry[column.key], column.pipes) }}
              </a>
            </div>

            <!-- Tooltip -->
            <ng-template #tipContent>
              <div [innerHTML]="column?.tooltip?.getValue(entry)"></div>
            </ng-template>

            <button
              *ngIf="
                column.tooltip &&
                !column.tooltip.cmsShield &&
                column.tooltip.shouldShow(entry)
              "
              class="harp-comments"
              placement="top"
              [ngbTooltip]="tipContent"
            >
              <em class="icon {{ getTooltipIcon(column) }}"></em>
            </button>
          </ng-container>

          <!-- Actions -->
          <div *ngIf="column.actions && !column.actionsDropdown">
            <button
              *ngFor="let action of column.actions; index as j"
              [hidden]="action.shouldShow ? action.shouldShow(entry) : false"
              [ngClass]="action.class"
              [ngStyle]="action.style"
              class="ms-2"
              [attr.aria-label]="
                action.getAriaLabel && action.getAriaLabel(entry)
              "
              (click)="
                action.onClick(
                  entry,
                  getContentId(formName + '-action-' + j, entry.rowId)
                )
              "
              [id]="getContentId(formName + '-action-' + j, entry.rowId)"
            >
              {{ action.name }}
            </button>
          </div>

          <div
            class="dropdown"
            *ngIf="column.actions && column.actionsDropdown"
          >
            <button
              role="button"
              type="button"
              class="link dropdown-toggle"
              [id]="getContentId(formName + '-actionsMenu', entry.rowId)"
              data-bs-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              [attr.aria-label]="
                column.getAriaLabel && column.getAriaLabel(entry)
              "
            >
              Actions
            </button>
            <div
              class="dropdown-menu dropdown-menu-end"
              [attr.aria-labelledby]="
                getContentId(formName + '-actionsMenu', entry.rowId)
              "
              role="menu"
            >
              <button
                *ngFor="let action of column.actions; index as i"
                [id]="getContentId(formName + '-action-' + i, entry.rowId)"
                [hidden]="action.shouldShow ? action.shouldShow(entry) : false"
                [ngClass]="action.class"
                [ngStyle]="action.style"
                [attr.aria-label]="
                  action?.getAriaLabel && action.getAriaLabel(entry)
                "
                class="dropdown-item"
                role="menuitem"
                (click)="
                  action.onClick(
                    entry,
                    getContentId(formName + '-actionsMenu', entry.rowId)
                  )
                "
              >
                {{ action.name }}
              </button>
            </div>
          </div>

          <!-- NOTE: This is used to calculate the row height. It's configured to not return a value. -->
          {{ maxHeight(colRef, column, rowNum, false) }}
        </div>
      </div>
    </div>
  </div>

  <!-- Table Body for API pagination 
       NOTE: the only difference is the ngFor
  -->
  <div
    id="table-body-{{ formName }}"
    class="harp-table"
    role="rowgroup"
    *ngIf="usePagination"
  >
    <div
      class="row"
      *ngFor="let entry of sortedData; let i = index; let rowNum = index"
      role="row"
    >
      <!-- Checkbox Column -->
      <div *ngIf="hasCheckbox" class="col-1" role="cell">
        <input
          type="checkbox"
          [value]="entry"
          (change)="onCheckboxChange(entry)"
          [checked]="isChecked(entry)"
          name="{{ i }}"
        />
        <label for="{{ i }}" class="visually-hidden">
          {{ getCheckboxLabel(entry) || '' }}
        </label>
      </div>

      <div
        *ngFor="let column of columns"
        [ngClass]="column.class"
        [ngStyle]="column.style"
        style="word-wrap: break-word"
        class="d-md-block"
        role="cell"
        #colRef
      >
        <div>
          <p
            *ngIf="column.showHeader"
            class="fw-bold d-md-none"
            role="columnheader"
          >
            {{ column.header }}
          </p>

          <div
            *ngIf="!column.actions && !column.link && entry[column.key] !== ''"
            [id]="getContentId(column.key, entry.rowId)"
          >
            <!-- Expand Truncated Content Button -->
            <button
              *ngIf="
                column.truncate && shouldRenderTruncateButton(colRef, rowNum)
              "
              class="btn btn-link float-end"
              (click)="colRef.clicked = !colRef.clicked"
            >
              <em
                [ngClass]="{
                  'icon ion-md-add': !colRef.clicked,
                  'icon ion-md-remove': colRef.clicked
                }"
                style="color: blue; z-index: -19"
              ></em>
            </button>

            <!-- Non Truncated Content-->
            <span
              *ngIf="!column.truncate || colRef.clicked"
              [attr.data-matomo-mask]="maskData ? '' : null"
            >
              {{ format(entry[column.key], column.pipes) }}
            </span>

            <!-- Truncated Content -->
            <span
              *ngIf="column.truncate && !colRef.clicked"
              class="ellipsis"
              [attr.data-matomo-mask]="maskData ? '' : null"
              [ngStyle]="{
                '-webkit-line-clamp': maxHeight(colRef, column, rowNum)
              }"
            >
              {{ format(entry[column.key], column.pipes) }}
            </span>
            <!-- Tooltip -->
            <ng-template #tipContent>
              <div [innerHTML]="column?.tooltip?.getValue(entry)"></div>
            </ng-template>

            <button
              *ngIf="column.tooltip && column.tooltip.shouldShow(entry)"
              class="harp-comments"
              placement="top"
              [ngbTooltip]="tipContent"
              aria-label="Request Comments"
            >
              <em class="icon {{ getTooltipIcon(column) }}"></em>
            </button>
          </div>

          <!-- Link -->
          <ng-container *ngIf="!column.actions && column.link">
            <div style="display: flex; align-items: center">
              <span
                *ngIf="
                  column?.tooltip?.shouldShow(entry) &&
                  column?.tooltip?.cmsShield
                "
                placement="top"
                [ngbTooltip]="tipContent"
                tooltipClass="cms-shield-tooptip"
                style="margin-right: 5px"
              >
                <svg style="height: 16px; width: 16px">
                  <path
                    d="M15.8663 3.37257L15.8383 2.92788L15.3996 2.84944C12.3297 2.29864 11.0482 1.90044 8.1834 0.60647L7.94952 0.5L7.71564 0.60647C4.85088 1.90044 3.56933 2.29864 0.499438 2.84944L0.0607808 2.92788L0.0327436 3.37257C-0.103893 5.54137 0.18748 7.56217 0.899767 9.37891C1.48305 10.8608 2.34628 12.2165 3.44228 13.3719C5.33993 15.3853 7.35471 16.2597 7.73906 16.4145L7.952 16.5L8.16494 16.4145C8.5493 16.2597 10.5641 15.3853 12.4617 13.3719C13.556 12.2161 14.4175 10.8604 14.9993 9.37891C15.7116 7.56217 16.0029 5.54137 15.8663 3.37257ZM6.89049 11.0384L4.30717 8.50586L5.10215 7.69455L6.82235 9.37998L10.7309 4.86564L11.5897 5.6088L6.89049 11.0384Z"
                    fill="#046B99"
                  />
                </svg>
              </span>
              <a
                *ngIf="!column.actions && column.link"
                [routerLink]=""
                (click)="column.link(entry)"
                [id]="getContentId(column.key, entry.rowId)"
                [attr.data-matomo-mask]="maskData ? '' : null"
              >
                {{ format(entry[column.key], column.pipes) }}
              </a>
            </div>

            <!-- Tooltip -->
            <ng-template #tipContent>
              <div [innerHTML]="column?.tooltip?.getValue(entry)"></div>
            </ng-template>

            <button
              *ngIf="
                column.tooltip &&
                !column.tooltip.cmsShield &&
                column.tooltip.shouldShow(entry)
              "
              class="harp-comments"
              placement="top"
              [ngbTooltip]="tipContent"
            >
              <em class="icon {{ getTooltipIcon(column) }}"></em>
            </button>
          </ng-container>

          <!-- Actions -->
          <div *ngIf="column.actions && !column.actionsDropdown">
            <button
              *ngFor="let action of column.actions; index as j"
              [hidden]="action.shouldShow ? action.shouldShow(entry) : false"
              [ngClass]="action.class"
              [ngStyle]="action.style"
              class="ms-2"
              [attr.aria-label]="
                action.getAriaLabel && action.getAriaLabel(entry)
              "
              (click)="
                action.onClick(
                  entry,
                  getContentId(formName + '-action-' + j, entry.rowId)
                )
              "
              [id]="getContentId(formName + '-action-' + j, entry.rowId)"
            >
              {{ action.name }}
            </button>
          </div>

          <div
            class="dropdown"
            *ngIf="column.actions && column.actionsDropdown"
          >
            <button
              role="button"
              type="button"
              class="link dropdown-toggle"
              [id]="getContentId(formName + '-actionsMenu', entry.rowId)"
              data-bs-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              [attr.aria-label]="
                column.getAriaLabel && column.getAriaLabel(entry)
              "
            >
              Actions
            </button>
            <div
              class="dropdown-menu dropdown-menu-end"
              [attr.aria-labelledby]="
                getContentId(formName + '-actionsMenu', entry.rowId)
              "
              role="menu"
            >
              <button
                *ngFor="let action of column.actions; index as i"
                [id]="getContentId(formName + '-action-' + i, entry.rowId)"
                [hidden]="action.shouldShow ? action.shouldShow(entry) : false"
                [ngClass]="action.class"
                [ngStyle]="action.style"
                [attr.aria-label]="
                  action?.getAriaLabel && action.getAriaLabel(entry)
                "
                class="dropdown-item"
                role="menuitem"
                (click)="
                  action.onClick(
                    entry,
                    getContentId(formName + '-actionsMenu', entry.rowId)
                  )
                "
              >
                {{ action.name }}
              </button>
            </div>
          </div>

          <!-- NOTE: This is used to calculate the row height. It's configured to not return a value. -->
          {{ maxHeight(colRef, column, rowNum, false) }}
        </div>
      </div>
    </div>
  </div>

  <!-- Pagination Widget -->
  <div
    *ngIf="hasPagination && totalEntries && totalEntries > originalPageSize"
    class="row"
  >
    <!-- Page Select -->
    <div class="col-9" aria-label="Page Select">
      <ngb-pagination
        id="page-select-widget-{{ formName }}"
        [rotate]="true"
        ellipses="true"
        maxSize="5"
        [collectionSize]="totalEntries"
        [(page)]="pageNumber"
        [pageSize]="pageSize"
        (pageChange)="onPageChange($event)"
      ></ngb-pagination>
    </div>

    <!-- Page Size Select -->
    <div
      *ngIf="showCustomPageSize"
      class="col-3 pe-0 float-end"
      style="min-width: 150px"
      aria-label="Page Size Select"
    >
      <ngb-pagination
        id="page-size-widget-{{ formName }}"
        class="me-0 pe-0 float-end"
        [directionLinks]="false"
        [collectionSize]="3"
        [page]="getPage()"
        [pageSize]="1"
        (pageChange)="updatePageSize($event - 1)"
      >
        <ng-template ngbPaginationNumber let-p>{{
          pageSizes[p - 1]
        }}</ng-template>
      </ngb-pagination>
    </div>
  </div>
</div>
